import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { styled } from '@mui/system';

const StatCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  backgroundColor: theme.palette.background.default,
  border: '1px solid rgba(0, 0, 0, 0.05)',
  borderRadius: 12,
}));

function StatsDashboard({ espacios }) {
  if (!espacios || espacios.length === 0) return null;

  const stats = {
    total: espacios.length,
    tipos: espacios.reduce((acc, current) => {
      acc[current.Tipo_Espacio] = (acc[current.Tipo_Espacio] || 0) + 1;
      return acc;
    }, {}),
    provincias: [...new Set(espacios.map(e => e.Provincia))].length,
  };

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: 'text.secondary', textAlign: 'center' }}>
        Resumen de la Selección
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <StatCard elevation={0}>
            <Typography variant="h6" color="primary">{stats.total}</Typography>
            <Typography variant="caption">Total Espacios</Typography>
          </StatCard>
        </Grid>
        <Grid item xs={6}>
          <StatCard elevation={0}>
            <Typography variant="h6" color="secondary">{stats.provincias}</Typography>
            <Typography variant="caption">Provincias</Typography>
          </StatCard>
        </Grid>
      </Grid>
      
      <Box sx={{ mt: 2 }}>
        <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 'bold', textAlign: 'center' }}>
          Breakdown por Tipo:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'center' }}>
          {Object.entries(stats.tipos).map(([tipo, count]) => (
            <Paper 
              key={tipo} 
              elevation={0} 
              sx={{ 
                px: 1, 
                py: 0.5, 
                backgroundColor: 'rgba(0, 87, 183, 0.05)', 
                borderRadius: 2,
                border: '1px solid rgba(0, 87, 183, 0.1)'
              }}
            >
              <Typography variant="caption" sx={{ color: 'primary.dark', fontWeight: 600 }}>
                {tipo}: {count}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default StatsDashboard;
